import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { formDataHeaders, requests, instance } from "../../utils/api/api.service";
import { COUNTRIES_URL, ROLES_URL, USER_URL } from "../../utils/api/endpoints";
import { IChangePassword, IUser } from "../../shared/interfaces/user/IUser";
import { IBaseModel } from "../../shared/interfaces/shared/IBase";

export const UserService = {
  getAll: (params: IPagination): Promise<IBaseModel<IUser[]>> =>
    requests.get(USER_URL, params),
  getSingle: (id: number) => requests.get(`${USER_URL}/${id}`),
  getImage: (id: number, width?: number, height?: number) => {
    const params = new URLSearchParams();
    if (width) params.append('width', width.toString());
    if (height) params.append('height', height.toString());
    const queryString = params.toString() ? `?${params.toString()}` : '';
    return requests.get(`${USER_URL}/${id}/image${queryString}`);
  },
  getImageBlob: async (id: number, width?: number, height?: number): Promise<string | null> => {
    const params = new URLSearchParams();
    if (width) params.append('width', width.toString());
    if (height) params.append('height', height.toString());
    const queryString = params.toString() ? `?${params.toString()}` : '';
    
    try {
      const response = await instance.get(`${USER_URL}/${id}/image${queryString}`, {
        responseType: 'blob',
      });
      
      if (response.data && response.data.size > 0) {
        return URL.createObjectURL(response.data);
      }
      return null;
    } catch (error) {
      console.error('Failed to fetch image blob:', error);
      return null;
    }
  },
  create: (payload: IUser, id?: number, file?: File | null) => {
    const formData = new FormData();
    // Send the entire object as JSON under 'request' key
    const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    formData.append('request', blob);
    if (file) {
      formData.append('file', file);
    }
    return requests.post(USER_URL, formData, formDataHeaders);
  },
  update: (payload: IUser, id?: number): Promise<IUser> =>
    requests.put(`${USER_URL}/${id}`, payload),
  changePassword: (payload: IChangePassword, id?: number): Promise<IUser> =>
    requests.put(`${USER_URL}/${id}/password`, payload),
  delete: (id: number) => requests.delete(`${USER_URL}/${id}`),
  getRoles: (): Promise<{ data: { name: string }[] }> =>
    requests.get(ROLES_URL),
  uploadImage: (id: number, file: FormData) =>
    requests.post(`${USER_URL}/${id}/image`, file, formDataHeaders),
  getCountries: (): Promise<{ data: { code: string }[] }> =>
    requests.get(COUNTRIES_URL),
};
